import React, { useState, useRef, useEffect, useCallback } from 'react';

const EMOJI_LIST = [
  { name: 'Target', emoji: '🎯' },
  { name: 'Fire', emoji: '🔥' },
  { name: 'Rocket', emoji: '🚀' },
  { name: 'Star', emoji: '⭐' },
  { name: 'Sparkles', emoji: '✨' },
  { name: 'Lightning', emoji: '⚡' },
  { name: 'Heart', emoji: '❤️' },
  { name: 'Check', emoji: '✅' },
  { name: 'Warning', emoji: '⚠️' },
  { name: 'Stop', emoji: '🛑' },
  { name: 'Traffic Light', emoji: '🚦' },
  { name: 'Light Bulb', emoji: '💡' },
  { name: 'Magnifying Glass', emoji: '🔍' },
  { name: 'Gear', emoji: '⚙️' },
  { name: 'Wrench', emoji: '🔧' },
  { name: 'Hammer', emoji: '🔨' },
  { name: 'Shield', emoji: '🛡️' },
  { name: 'Lock', emoji: '🔒' },
  { name: 'Key', emoji: '🔑' },
  { name: 'Link', emoji: '🔗' },
  { name: 'Clipboard', emoji: '📋' },
  { name: 'Folder', emoji: '📁' },
  { name: 'File', emoji: '📄' },
  { name: 'Book', emoji: '📖' },
  { name: 'Pencil', emoji: '✏️' },
  { name: 'Paintbrush', emoji: '🖌️' },
  { name: 'Palette', emoji: '🎨' },
  { name: 'Camera', emoji: '📷' },
  { name: 'Video', emoji: '🎥' },
  { name: 'Music', emoji: '🎵' },
  { name: 'Microphone', emoji: '🎤' },
  { name: 'Headphones', emoji: '🎧' },
  { name: 'Phone', emoji: '📱' },
  { name: 'Computer', emoji: '💻' },
  { name: 'Globe', emoji: '🌍' },
  { name: 'Cloud', emoji: '☁️' },
  { name: 'Sun', emoji: '☀️' },
  { name: 'Moon', emoji: '🌙' },
  { name: 'Rainbow', emoji: '🌈' },
  { name: 'Tree', emoji: '🌳' },
  { name: 'Flower', emoji: '🌸' },
  { name: 'Leaf', emoji: '🍃' },
  { name: 'Bug', emoji: '🐛' },
  { name: 'Butterfly', emoji: '🦋' },
  { name: 'Dog', emoji: '🐕' },
  { name: 'Cat', emoji: '🐈' },
  { name: 'Robot', emoji: '🤖' },
  { name: 'Ghost', emoji: '👻' },
  { name: 'Alien', emoji: '👽' },
  { name: 'Crown', emoji: '👑' },
  { name: 'Diamond', emoji: '💎' },
  { name: 'Money', emoji: '💰' },
  { name: 'Gift', emoji: '🎁' },
  { name: 'Trophy', emoji: '🏆' },
  { name: 'Medal', emoji: '🏅' },
  { name: 'Flag', emoji: '🚩' },
  { name: 'Bell', emoji: '🔔' },
  { name: 'Clock', emoji: '🕐' },
  { name: 'Hourglass', emoji: '⏳' },
  { name: 'Battery', emoji: '🔋' },
  { name: 'Plug', emoji: '🔌' },
  { name: 'Magnet', emoji: '🧲' },
  { name: 'Test Tube', emoji: '🧪' },
  { name: 'Microscope', emoji: '🔬' },
  { name: 'Telescope', emoji: '🔭' },
  { name: 'Pill', emoji: '💊' },
  { name: 'DNA', emoji: '🧬' },
  { name: 'Brain', emoji: '🧠' },
  { name: 'Eyes', emoji: '👀' },
  { name: 'Thumbs Up', emoji: '👍' },
  { name: 'Clap', emoji: '👏' },
  { name: 'Wave', emoji: '👋' },
  { name: 'Handshake', emoji: '🤝' },
  { name: 'Pray', emoji: '🙏' },
  { name: 'Muscle', emoji: '💪' },
  { name: 'Running', emoji: '🏃' },
  { name: 'Puzzle', emoji: '🧩' },
  { name: 'Dice', emoji: '🎲' },
  { name: 'Chess', emoji: '♟️' },
  { name: 'Brick', emoji: '🧱' },
  { name: 'Package', emoji: '📦' },
  { name: 'Mail', emoji: '📧' },
  { name: 'Megaphone', emoji: '📣' },
  { name: 'Pin', emoji: '📌' },
  { name: 'Scissors', emoji: '✂️' },
  { name: 'Recycle', emoji: '♻️' },
  { name: 'Infinity', emoji: '♾️' },
  { name: 'Atom', emoji: '⚛️' },
  { name: 'Zap', emoji: '💥' },
  { name: 'Snowflake', emoji: '❄️' },
  { name: 'Flame', emoji: '🔥' },
  { name: 'Wave Water', emoji: '🌊' },
  { name: 'Mountain', emoji: '⛰️' },
  { name: 'Compass', emoji: '🧭' },
  { name: 'Map', emoji: '🗺️' },
  { name: 'House', emoji: '🏠' },
  { name: 'Hospital', emoji: '🏥' },
  { name: 'School', emoji: '🏫' },
  { name: 'Bank', emoji: '🏦' },
  { name: 'Factory', emoji: '🏭' },
  { name: 'Satellite', emoji: '🛰️' },
  { name: 'Airplane', emoji: '✈️' },
  { name: 'Car', emoji: '🚗' },
  { name: 'Bike', emoji: '🚲' },
  { name: 'Ship', emoji: '🚢' },
  { name: 'Anchor', emoji: '⚓' },
  { name: 'Construction', emoji: '🚧' },
  { name: 'Traffic Cone', emoji: '🔶' },
  { name: 'Chart Up', emoji: '📈' },
  { name: 'Chart Down', emoji: '📉' },
  { name: 'Bar Chart', emoji: '📊' },
  { name: 'Calendar', emoji: '📅' },
  { name: 'Bookmark', emoji: '🔖' },
  { name: 'Tag', emoji: '🏷️' },
  { name: 'Broom', emoji: '🧹' },
  { name: 'Basket', emoji: '🧺' },
  { name: 'Toolbox', emoji: '🧰' },
  { name: 'Chains', emoji: '⛓️' },
  { name: 'Hook', emoji: '🪝' },
  { name: 'Ladder', emoji: '🪜' },
  { name: 'Door', emoji: '🚪' },
  { name: 'Window', emoji: '🪟' },
  { name: 'Mirror', emoji: '🪞' },
  { name: 'Glasses', emoji: '👓' },
  { name: 'Pen', emoji: '🖊️' },
  { name: 'Crayon', emoji: '🖍️' },
  { name: 'Newspaper', emoji: '📰' },
  { name: 'Scroll', emoji: '📜' },
  { name: 'Label', emoji: '🏷️' },
  { name: 'Coffee', emoji: '☕' },
  { name: 'Pizza', emoji: '🍕' },
  { name: 'Apple', emoji: '🍎' },
  { name: 'Popcorn', emoji: '🍿' },
  { name: 'Cookie', emoji: '🍪' },
  { name: 'Cake', emoji: '🎂' },
  { name: 'Party', emoji: '🎉' },
  { name: 'Balloon', emoji: '🎈' },
  { name: 'Confetti', emoji: '🎊' },
  { name: 'Fireworks', emoji: '🎆' },
];

export function TextField({ label, value, onChange, placeholder, multiline, maxLength }) {
  const textareaRef = useRef(null);
  const len = (value || '').length;
  const atLimit = maxLength && len >= maxLength;

  const autoResize = useCallback(() => {
    const el = textareaRef.current;
    if (el) {
      el.style.height = 'auto';
      el.style.height = el.scrollHeight + 'px';
    }
  }, []);

  useEffect(() => {
    if (multiline) {
      autoResize();
    }
  }, [value, multiline, autoResize]);

  const handleChange = (e) => {
    const v = e.target.value;
    if (maxLength && v.length > maxLength) return;
    onChange(v);
  };

  return (
    <div style={{ marginBottom: '16px' }}>
      <div style={{
        display: 'flex',
        alignItems: 'baseline',
        justifyContent: 'space-between',
        marginBottom: '6px'
      }}>
        <label style={{
          fontSize: '12px',
          fontWeight: 500,
          color: '#374151'
        }}>
          {label}
        </label>
        {maxLength && (
          <span style={{
            fontSize: '11px',
            color: atLimit ? '#ef4444' : '#9ca3af',
            fontWeight: 500,
            transition: 'color 0.15s ease'
          }}>
            {len}/{maxLength}
          </span>
        )}
      </div>
      {multiline ? (
        <textarea
          ref={textareaRef}
          value={value || ''}
          onChange={(e) => {
            handleChange(e);
            autoResize();
          }}
          placeholder={placeholder}
          rows={2}
          style={{
            width: '100%',
            boxSizing: 'border-box',
            padding: '10px 12px',
            border: `1px solid ${atLimit ? '#fca5a5' : '#e5e7eb'}`,
            borderRadius: '8px',
            fontSize: '13px',
            fontFamily: 'inherit',
            resize: 'none',
            overflow: 'hidden',
            outline: 'none'
          }}
          onFocus={(e) => e.target.style.borderColor = atLimit ? '#ef4444' : '#3b82f6'}
          onBlur={(e) => e.target.style.borderColor = atLimit ? '#fca5a5' : '#e5e7eb'}
        />
      ) : (
        <input
          type="text"
          value={value || ''}
          onChange={handleChange}
          placeholder={placeholder}
          style={{
            width: '100%',
            boxSizing: 'border-box',
            padding: '10px 12px',
            border: `1px solid ${atLimit ? '#fca5a5' : '#e5e7eb'}`,
            borderRadius: '8px',
            fontSize: '13px',
            outline: 'none'
          }}
          onFocus={(e) => e.target.style.borderColor = atLimit ? '#ef4444' : '#3b82f6'}
          onBlur={(e) => e.target.style.borderColor = atLimit ? '#fca5a5' : '#e5e7eb'}
        />
      )}
    </div>
  );
}

export function ToggleField({ label, value, onChange, description }) {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: '16px',
      padding: '12px',
      background: '#f9fafb',
      borderRadius: '8px'
    }}>
      <div>
        <div style={{ fontSize: '13px', fontWeight: 500, color: '#374151' }}>{label}</div>
        {description && (
          <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '2px' }}>{description}</div>
        )}
      </div>
      <button
        onClick={() => onChange(!value)}
        style={{
          width: '44px',
          height: '24px',
          borderRadius: '12px',
          border: 'none',
          background: value ? '#ef4444' : '#e5e7eb',
          cursor: 'pointer',
          position: 'relative',
          transition: 'background 0.2s ease'
        }}
      >
        <div style={{
          width: '20px',
          height: '20px',
          borderRadius: '50%',
          background: '#fff',
          position: 'absolute',
          top: '2px',
          left: value ? '22px' : '2px',
          transition: 'left 0.2s ease',
          boxShadow: '0 1px 3px rgba(0,0,0,0.2)'
        }} />
      </button>
    </div>
  );
}

export function SelectField({ label, value, onChange, options, showDescriptions }) {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    function handleClick(e) {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    if (open) document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open]);

  const selectedOption = options.find(opt => opt.value === value);

  // If showDescriptions is enabled, use custom dropdown
  if (showDescriptions) {
    return (
      <div style={{ marginBottom: '16px', position: 'relative' }} ref={containerRef}>
        <label style={{
          display: 'block',
          fontSize: '12px',
          fontWeight: 500,
          color: '#374151',
          marginBottom: '6px'
        }}>
          {label}
        </label>
        <div
          onClick={() => setOpen(!open)}
          style={{
            width: '100%',
            boxSizing: 'border-box',
            padding: '10px 12px',
            border: `1px solid ${open ? '#3b82f6' : '#e5e7eb'}`,
            borderRadius: '8px',
            fontSize: '13px',
            background: '#fff',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            transition: 'border-color 0.15s ease'
          }}
        >
          <span style={{ color: '#111827' }}>
            {selectedOption?.label || 'Select...'}
          </span>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="#6b7280" style={{ width: '14px', height: '14px', transition: 'transform 0.2s ease', transform: open ? 'rotate(180deg)' : 'rotate(0deg)' }}>
            <path fillRule="evenodd" d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clipRule="evenodd" />
          </svg>
        </div>
        {open && (
          <div style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            marginTop: '4px',
            background: '#fff',
            border: '1px solid #e5e7eb',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
            zIndex: 50,
            overflow: 'hidden'
          }}>
            {options.map((opt) => (
              <div
                key={opt.value}
                onClick={() => {
                  onChange(opt.value);
                  setOpen(false);
                }}
                style={{
                  padding: '10px 14px',
                  cursor: 'pointer',
                  background: value === opt.value ? '#eff6ff' : 'transparent',
                  borderBottom: '1px solid #f3f4f6',
                  transition: 'background 0.1s ease'
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = value === opt.value ? '#dbeafe' : '#f9fafb'}
                onMouseLeave={(e) => e.currentTarget.style.background = value === opt.value ? '#eff6ff' : 'transparent'}
              >
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    {value === opt.value && (
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="#3b82f6" style={{ width: '14px', height: '14px', flexShrink: 0 }}>
                        <path fillRule="evenodd" d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" clipRule="evenodd" />
                      </svg>
                    )}
                    <span style={{ fontSize: '13px', fontWeight: value === opt.value ? 600 : 500, color: '#111827' }}>
                      {opt.label}
                    </span>
                  </div>
                  {opt.description && (
                    <span style={{ fontSize: '11px', color: '#9ca3af', textAlign: 'right' }}>
                      {opt.description}
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  // Default native select (no descriptions)
  return (
    <div style={{ marginBottom: '16px' }}>
      <label style={{
        display: 'block',
        fontSize: '12px',
        fontWeight: 500,
        color: '#374151',
        marginBottom: '6px'
      }}>
        {label}
      </label>
      <select
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        style={{
          width: '100%',
          padding: '10px 12px',
          border: '1px solid #e5e7eb',
          borderRadius: '8px',
          fontSize: '13px',
          background: '#fff',
          cursor: 'pointer',
          outline: 'none'
        }}
        onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
        onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
      >
        {options.map(opt => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
    </div>
  );
}

export function EmojiPickerField({ label, value, onChange }) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const containerRef = useRef(null);
  const searchRef = useRef(null);

  useEffect(() => {
    if (open && searchRef.current) searchRef.current.focus();
  }, [open]);

  useEffect(() => {
    function handleClick(e) {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
        setSearch('');
      }
    }
    if (open) document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open]);

  const filtered = EMOJI_LIST.filter(e =>
    e.name.toLowerCase().includes(search.toLowerCase())
  );

  const selectedEntry = EMOJI_LIST.find(e => e.emoji === value);

  return (
    <div style={{ marginBottom: '16px', position: 'relative' }} ref={containerRef}>
      <label style={{
        display: 'block',
        fontSize: '12px',
        fontWeight: 500,
        color: '#374151',
        marginBottom: '6px'
      }}>
        {label}
      </label>
      <div
        onClick={() => setOpen(!open)}
        style={{
          width: '100%',
          boxSizing: 'border-box',
          padding: '10px 12px',
          border: `1px solid ${open ? '#3b82f6' : '#e5e7eb'}`,
          borderRadius: '8px',
          fontSize: '13px',
          background: '#fff',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          transition: 'border-color 0.15s ease'
        }}
      >
        <span style={{ color: value ? '#111827' : '#9ca3af' }}>
          {selectedEntry ? selectedEntry.name : (value || 'Choose emoji...')}
        </span>
        <span style={{ fontSize: '18px', lineHeight: 1 }}>{value || ''}</span>
      </div>
      {open && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          marginTop: '4px',
          background: '#fff',
          border: '1px solid #e5e7eb',
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          zIndex: 50,
          overflow: 'hidden'
        }}>
          <div style={{ padding: '8px' }}>
            <input
              ref={searchRef}
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search emojis..."
              style={{
                width: '100%',
                boxSizing: 'border-box',
                padding: '8px 10px',
                border: '1px solid #e5e7eb',
                borderRadius: '6px',
                fontSize: '13px',
                outline: 'none'
              }}
              onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
              onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
            />
          </div>
          <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
            {filtered.length === 0 ? (
              <div style={{ padding: '12px', textAlign: 'center', color: '#9ca3af', fontSize: '13px' }}>
                No emojis found
              </div>
            ) : (
              filtered.map((entry) => (
                <div
                  key={entry.name + entry.emoji}
                  onClick={() => {
                    onChange(entry.emoji);
                    setOpen(false);
                    setSearch('');
                  }}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '8px 12px',
                    cursor: 'pointer',
                    background: value === entry.emoji ? '#eff6ff' : 'transparent',
                    transition: 'background 0.1s ease'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.background = value === entry.emoji ? '#dbeafe' : '#f9fafb'}
                  onMouseLeave={(e) => e.currentTarget.style.background = value === entry.emoji ? '#eff6ff' : 'transparent'}
                >
                  <span style={{ fontSize: '13px', color: '#374151' }}>{entry.name}</span>
                  <span style={{ fontSize: '18px', lineHeight: 1 }}>{entry.emoji}</span>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}
